"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubscriptionRenewalGenerationTypeEnum = void 0;
var SubscriptionRenewalGenerationTypeEnum;
(function (SubscriptionRenewalGenerationTypeEnum) {
    SubscriptionRenewalGenerationTypeEnum[SubscriptionRenewalGenerationTypeEnum["BY_DATE"] = 0] = "BY_DATE";
    // only possible for card subscriptions
    SubscriptionRenewalGenerationTypeEnum[SubscriptionRenewalGenerationTypeEnum["BY_TRANSACTION"] = 1] = "BY_TRANSACTION";
})(SubscriptionRenewalGenerationTypeEnum || (exports.SubscriptionRenewalGenerationTypeEnum = SubscriptionRenewalGenerationTypeEnum = {}));
